import { render } from "./VideoRequest.vue?vue&type=template&id=3d0115ae&scoped=true"
import script from "./VideoRequest.vue?vue&type=script&lang=js"
export * from "./VideoRequest.vue?vue&type=script&lang=js"

import "./VideoRequest.scss?vue&type=style&index=0&id=3d0115ae&lang=scss&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0115ae"]])

export default __exports__